/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/~__root'
import { Route as VerifyEmailRouteImport } from './routes/~verify-email'
import { Route as SignUpRouteImport } from './routes/~sign-up'
import { Route as ResetPasswordRouteImport } from './routes/~reset-password'
import { Route as RequestPasswordResetRouteImport } from './routes/~request-password-reset'
import { Route as LogInRouteImport } from './routes/~log-in'
import { Route as IndexRouteImport } from './routes/~index'
import { Route as TestSlugResultsIndexRouteImport } from './routes/~$test-slug/~results/~index'
import { Route as TestSlugMySchoolIndexRouteImport } from './routes/~$test-slug/~my-school/~index'
import { Route as TestSlugHomeIndexRouteImport } from './routes/~$test-slug/~home/~index'
import { Route as TestSlugGroupsIdIndexRouteImport } from './routes/~$test-slug/~groups/~$id/~index'
import { Route as TestSlugGroupsIdReviewIndexRouteImport } from './routes/~$test-slug/~groups/~$id/~review/~index'
import { Route as TestSlugGroupsIdInspectScansIndexRouteImport } from './routes/~$test-slug/~groups/~$id/~inspect-scans/~index'
import { Route as TestSlugGroupsIdConfigureIndexRouteImport } from './routes/~$test-slug/~groups/~$id/~configure/~index'

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => rootRouteImport,
} as any)
const SignUpRoute = SignUpRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => rootRouteImport,
} as any)
const RequestPasswordResetRoute = RequestPasswordResetRouteImport.update({
  id: '/request-password-reset',
  path: '/request-password-reset',
  getParentRoute: () => rootRouteImport,
} as any)
const LogInRoute = LogInRouteImport.update({
  id: '/log-in',
  path: '/log-in',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestSlugResultsIndexRoute = TestSlugResultsIndexRouteImport.update({
  id: '/$test-slug/results/',
  path: '/$test-slug/results/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestSlugMySchoolIndexRoute = TestSlugMySchoolIndexRouteImport.update({
  id: '/$test-slug/my-school/',
  path: '/$test-slug/my-school/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestSlugHomeIndexRoute = TestSlugHomeIndexRouteImport.update({
  id: '/$test-slug/home/',
  path: '/$test-slug/home/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestSlugGroupsIdIndexRoute = TestSlugGroupsIdIndexRouteImport.update({
  id: '/$test-slug/groups/$id/',
  path: '/$test-slug/groups/$id/',
  getParentRoute: () => rootRouteImport,
} as any)
const TestSlugGroupsIdReviewIndexRoute =
  TestSlugGroupsIdReviewIndexRouteImport.update({
    id: '/$test-slug/groups/$id/review/',
    path: '/$test-slug/groups/$id/review/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TestSlugGroupsIdInspectScansIndexRoute =
  TestSlugGroupsIdInspectScansIndexRouteImport.update({
    id: '/$test-slug/groups/$id/inspect-scans/',
    path: '/$test-slug/groups/$id/inspect-scans/',
    getParentRoute: () => rootRouteImport,
  } as any)
const TestSlugGroupsIdConfigureIndexRoute =
  TestSlugGroupsIdConfigureIndexRouteImport.update({
    id: '/$test-slug/groups/$id/configure/',
    path: '/$test-slug/groups/$id/configure/',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/log-in': typeof LogInRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/$test-slug/home': typeof TestSlugHomeIndexRoute
  '/$test-slug/my-school': typeof TestSlugMySchoolIndexRoute
  '/$test-slug/results': typeof TestSlugResultsIndexRoute
  '/$test-slug/groups/$id': typeof TestSlugGroupsIdIndexRoute
  '/$test-slug/groups/$id/configure': typeof TestSlugGroupsIdConfigureIndexRoute
  '/$test-slug/groups/$id/inspect-scans': typeof TestSlugGroupsIdInspectScansIndexRoute
  '/$test-slug/groups/$id/review': typeof TestSlugGroupsIdReviewIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/log-in': typeof LogInRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/$test-slug/home': typeof TestSlugHomeIndexRoute
  '/$test-slug/my-school': typeof TestSlugMySchoolIndexRoute
  '/$test-slug/results': typeof TestSlugResultsIndexRoute
  '/$test-slug/groups/$id': typeof TestSlugGroupsIdIndexRoute
  '/$test-slug/groups/$id/configure': typeof TestSlugGroupsIdConfigureIndexRoute
  '/$test-slug/groups/$id/inspect-scans': typeof TestSlugGroupsIdInspectScansIndexRoute
  '/$test-slug/groups/$id/review': typeof TestSlugGroupsIdReviewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/log-in': typeof LogInRoute
  '/request-password-reset': typeof RequestPasswordResetRoute
  '/reset-password': typeof ResetPasswordRoute
  '/sign-up': typeof SignUpRoute
  '/verify-email': typeof VerifyEmailRoute
  '/$test-slug/home/': typeof TestSlugHomeIndexRoute
  '/$test-slug/my-school/': typeof TestSlugMySchoolIndexRoute
  '/$test-slug/results/': typeof TestSlugResultsIndexRoute
  '/$test-slug/groups/$id/': typeof TestSlugGroupsIdIndexRoute
  '/$test-slug/groups/$id/configure/': typeof TestSlugGroupsIdConfigureIndexRoute
  '/$test-slug/groups/$id/inspect-scans/': typeof TestSlugGroupsIdInspectScansIndexRoute
  '/$test-slug/groups/$id/review/': typeof TestSlugGroupsIdReviewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/log-in'
    | '/request-password-reset'
    | '/reset-password'
    | '/sign-up'
    | '/verify-email'
    | '/$test-slug/home'
    | '/$test-slug/my-school'
    | '/$test-slug/results'
    | '/$test-slug/groups/$id'
    | '/$test-slug/groups/$id/configure'
    | '/$test-slug/groups/$id/inspect-scans'
    | '/$test-slug/groups/$id/review'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/log-in'
    | '/request-password-reset'
    | '/reset-password'
    | '/sign-up'
    | '/verify-email'
    | '/$test-slug/home'
    | '/$test-slug/my-school'
    | '/$test-slug/results'
    | '/$test-slug/groups/$id'
    | '/$test-slug/groups/$id/configure'
    | '/$test-slug/groups/$id/inspect-scans'
    | '/$test-slug/groups/$id/review'
  id:
    | '__root__'
    | '/'
    | '/log-in'
    | '/request-password-reset'
    | '/reset-password'
    | '/sign-up'
    | '/verify-email'
    | '/$test-slug/home/'
    | '/$test-slug/my-school/'
    | '/$test-slug/results/'
    | '/$test-slug/groups/$id/'
    | '/$test-slug/groups/$id/configure/'
    | '/$test-slug/groups/$id/inspect-scans/'
    | '/$test-slug/groups/$id/review/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LogInRoute: typeof LogInRoute
  RequestPasswordResetRoute: typeof RequestPasswordResetRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  SignUpRoute: typeof SignUpRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
  TestSlugHomeIndexRoute: typeof TestSlugHomeIndexRoute
  TestSlugMySchoolIndexRoute: typeof TestSlugMySchoolIndexRoute
  TestSlugResultsIndexRoute: typeof TestSlugResultsIndexRoute
  TestSlugGroupsIdIndexRoute: typeof TestSlugGroupsIdIndexRoute
  TestSlugGroupsIdConfigureIndexRoute: typeof TestSlugGroupsIdConfigureIndexRoute
  TestSlugGroupsIdInspectScansIndexRoute: typeof TestSlugGroupsIdInspectScansIndexRoute
  TestSlugGroupsIdReviewIndexRoute: typeof TestSlugGroupsIdReviewIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/verify-email': {
      id: '/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-up': {
      id: '/sign-up'
      path: '/sign-up'
      fullPath: '/sign-up'
      preLoaderRoute: typeof SignUpRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reset-password': {
      id: '/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/request-password-reset': {
      id: '/request-password-reset'
      path: '/request-password-reset'
      fullPath: '/request-password-reset'
      preLoaderRoute: typeof RequestPasswordResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/log-in': {
      id: '/log-in'
      path: '/log-in'
      fullPath: '/log-in'
      preLoaderRoute: typeof LogInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$test-slug/results/': {
      id: '/$test-slug/results/'
      path: '/$test-slug/results'
      fullPath: '/$test-slug/results'
      preLoaderRoute: typeof TestSlugResultsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$test-slug/my-school/': {
      id: '/$test-slug/my-school/'
      path: '/$test-slug/my-school'
      fullPath: '/$test-slug/my-school'
      preLoaderRoute: typeof TestSlugMySchoolIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$test-slug/home/': {
      id: '/$test-slug/home/'
      path: '/$test-slug/home'
      fullPath: '/$test-slug/home'
      preLoaderRoute: typeof TestSlugHomeIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$test-slug/groups/$id/': {
      id: '/$test-slug/groups/$id/'
      path: '/$test-slug/groups/$id'
      fullPath: '/$test-slug/groups/$id'
      preLoaderRoute: typeof TestSlugGroupsIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$test-slug/groups/$id/review/': {
      id: '/$test-slug/groups/$id/review/'
      path: '/$test-slug/groups/$id/review'
      fullPath: '/$test-slug/groups/$id/review'
      preLoaderRoute: typeof TestSlugGroupsIdReviewIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$test-slug/groups/$id/inspect-scans/': {
      id: '/$test-slug/groups/$id/inspect-scans/'
      path: '/$test-slug/groups/$id/inspect-scans'
      fullPath: '/$test-slug/groups/$id/inspect-scans'
      preLoaderRoute: typeof TestSlugGroupsIdInspectScansIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$test-slug/groups/$id/configure/': {
      id: '/$test-slug/groups/$id/configure/'
      path: '/$test-slug/groups/$id/configure'
      fullPath: '/$test-slug/groups/$id/configure'
      preLoaderRoute: typeof TestSlugGroupsIdConfigureIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LogInRoute: LogInRoute,
  RequestPasswordResetRoute: RequestPasswordResetRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  SignUpRoute: SignUpRoute,
  VerifyEmailRoute: VerifyEmailRoute,
  TestSlugHomeIndexRoute: TestSlugHomeIndexRoute,
  TestSlugMySchoolIndexRoute: TestSlugMySchoolIndexRoute,
  TestSlugResultsIndexRoute: TestSlugResultsIndexRoute,
  TestSlugGroupsIdIndexRoute: TestSlugGroupsIdIndexRoute,
  TestSlugGroupsIdConfigureIndexRoute: TestSlugGroupsIdConfigureIndexRoute,
  TestSlugGroupsIdInspectScansIndexRoute:
    TestSlugGroupsIdInspectScansIndexRoute,
  TestSlugGroupsIdReviewIndexRoute: TestSlugGroupsIdReviewIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
